




























import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppSection2 from '@/components/AppSection2.vue'
import TopBar2 from '@/components/TopBar2.vue'
import { VIEW_SECTION_CONNECTION } from '@/gql/shopping'
import { Common } from '@/mixins'

@Component({
  components: {
    AppSection2,
    TopBar2
  },
  apollo: {
    viewSectionConnection: {
      query: VIEW_SECTION_CONNECTION,
      variables () {
        return {
          screenType: 'CATEGORY'
        }
      }
    }
  }
})
export default class extends Mixins(Common) {
  @Prop(Array) readonly itemIds!: string[]

  viewSectionConnection = {}

  routeToItems (term: string) {
    this.routerPush({ path: '/feeds/new/items', query: { term } })
  }
}
